/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsMessageAttachmentSendResponse
 */
export interface NotificationsMessageAttachmentSendResponse {
    /**
     * 
     * @type {string}
     * @memberof NotificationsMessageAttachmentSendResponse
     */
    message_uid: string;
}

/**
 * Check if a given object implements the NotificationsMessageAttachmentSendResponse interface.
 */
export function instanceOfNotificationsMessageAttachmentSendResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message_uid" in value;

    return isInstance;
}

export function NotificationsMessageAttachmentSendResponseFromJSON(json: any): NotificationsMessageAttachmentSendResponse {
    return NotificationsMessageAttachmentSendResponseFromJSONTyped(json, false);
}

export function NotificationsMessageAttachmentSendResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsMessageAttachmentSendResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message_uid': json['message_uid'],
    };
}

export function NotificationsMessageAttachmentSendResponseToJSON(value?: NotificationsMessageAttachmentSendResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message_uid': value.message_uid,
    };
}

